// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Js_null_undefined = require("rescript/lib/js/js_null_undefined.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var XPath$SmartcutsMacros = require("./XPath.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function toString(cmd) {
  switch (cmd) {
    case /* Paste */0 :
        return "paste";
    case /* Copy */1 :
        return "copy";
    case /* Cut */2 :
        return "cut";
    
  }
}

var Command = {
  toString: toString
};

var ExecCommand = {
  Command: Command
};

function execCommand(command) {
  document.execCommand(toString(command));
  
}

var Evaluate = {};

function evaluate(xpathExpression, contextNode, namespaceResolver, resultType, result, htmlDocument) {
  return htmlDocument.evaluate(xpathExpression, contextNode, Js_null_undefined.fromOption(namespaceResolver), XPath$SmartcutsMacros.Result.resultTypeToJs(resultType), Js_null_undefined.fromOption(result));
}

function getActiveElement(param) {
  return OptionUtils$SmartcutsMacros.andThen((function (prim) {
                return Caml_option.nullable_to_opt(prim.activeElement);
              }), Webapi__Dom__Document.asHtmlDocument(document));
}

function getActiveHtmlElement(param) {
  return OptionUtils$SmartcutsMacros.andThen(Webapi__Dom__Element.asHtmlElement, OptionUtils$SmartcutsMacros.andThen((function (prim) {
                    return Caml_option.nullable_to_opt(prim.activeElement);
                  }), Webapi__Dom__Document.asHtmlDocument(document)));
}

function getBodyExn(param) {
  var arg = Webapi__Dom__Document.asHtmlDocument(document);
  var arg$1 = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect htmlDocument").body;
  var arg$2 = (arg$1 == null) ? undefined : Caml_option.some(arg$1);
  var param$1 = "Expect htmlDocument.body";
  return OptionUtils$SmartcutsMacros.getExn(param$1, arg$2);
}

exports.ExecCommand = ExecCommand;
exports.execCommand = execCommand;
exports.Evaluate = Evaluate;
exports.evaluate = evaluate;
exports.getActiveElement = getActiveElement;
exports.getActiveHtmlElement = getActiveHtmlElement;
exports.getBodyExn = getBodyExn;
/* Webapi__Dom__Element Not a pure module */
